module.exports = __webpack_public_path__ + "img/3.1936ace1.jpg";